import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type UpsertRfidScansMutationVariables = Types.Exact<{
  input: Array<Types.RfidScanInputDataInput> | Types.RfidScanInputDataInput;
}>;


export type UpsertRfidScansMutation = { __typename?: 'Mutation', upsertRfidScans: { __typename?: 'UpsertRfidScansPayload', rfidScans?: Array<{ __typename?: 'RfidScanDocument', id: string, serialId: string, locationId: string }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null } };

export type RfidScanFieldsFragment = { __typename?: 'RfidScanDocument', id: string, serialId: string, locationId: string };

export const RfidScanFieldsFragmentDoc = new TypedDocumentString(`
    fragment RfidScanFields on RfidScanDocument {
  id
  serialId
  locationId
}
    `, {"fragmentName":"RfidScanFields"});
export const UpsertRfidScansDocument = new TypedDocumentString(`
    mutation UpsertRfidScans($input: [RfidScanInputDataInput!]!) {
  upsertRfidScans(input: $input) {
    rfidScans {
      ...RfidScanFields
    }
    errors {
      ...RecordValidationError
    }
  }
}
    fragment RfidScanFields on RfidScanDocument {
  id
  serialId
  locationId
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    UpsertRfidScans: build.mutation<UpsertRfidScansMutation, UpsertRfidScansMutationVariables>({
      query: (variables) => ({ document: UpsertRfidScansDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useUpsertRfidScansMutation } = injectedRtkApi;
